import { Action } from '@ngrx/store';

import { NotificationActionType } from './notification-action-type.enum';

export class SelectNotification implements Action {
  public readonly type: NotificationActionType = NotificationActionType.SelectNotification;

  constructor(public readonly payload: number) { }
}

export class SelectNotificationCompleted implements Action {
  public readonly type: NotificationActionType = NotificationActionType.SelectNotificationCompleted;

  constructor(public readonly payload: number) { }
}

export class SelectNotificationFailed implements Action {
  public readonly type: NotificationActionType = NotificationActionType.SelectNotificationFailed;

  constructor(public readonly payload: string) { }
}
